export enum SelfIssuedReceiptsListFilterKeys {
  selectedWarehouses = 'selectedWarehouses',
  creationDateFrom = 'creationDateFrom',
  creationDateTo = 'creationDateTo',
  isApplicable = 'isApplicable',
}

export enum ContractApplicabilityFilter {
  APPLICABLE = 'applicable',
  INAPPLICABLE = 'inapplicable',
}
